module.exports = __webpack_public_path__ + "img/pic_suppay_backapp@3x.7eacae72.png";